import {
  AddCompanyCardsTicketFareCommand,
  AddEWalletTransactionForEshopCommand,
  AddOffenseCommand,
  AddTicketFareCommand,
  ApiResponse,
  ChangeFeeCommand,
  EshopShoppingCartController,
  ShoppingCartItemResponse,
  ShoppingCartItemVm,
  ShoppingCartResponse,
  ShoppingCartVm,
} from '@/api';
import { getRequestBody } from '@/utils/api';

export default {
  getShoppingCart: async (): Promise<ShoppingCartVm> => {
    const response = await EshopShoppingCartController.getShoppingCart();

    return (response.data as ShoppingCartResponse).data;
  },

  getShoppingCartCount: async (): Promise<number | undefined> => {
    const { data } = await EshopShoppingCartController.getShoppingCartItemsCount();

    return data?.data;
  },

  chargeFee: async (body: ChangeFeeCommand): Promise<ShoppingCartItemVm> => {
    const response = await EshopShoppingCartController.addFeeToShoppingCart({ body });

    return (response.data as ShoppingCartItemResponse).data;
  },

  createEWalletTransaction: async (payload: AddEWalletTransactionForEshopCommand): Promise<ShoppingCartItemVm> => {
    const response = await EshopShoppingCartController.addElectronicWalletTransactionToShoppingCart({
      body: getRequestBody(payload),
    });

    return (response.data as ShoppingCartItemResponse).data;
  },

  addTicketFare: async (payload: AddTicketFareCommand): Promise<ShoppingCartItemVm> => {
    const response = await EshopShoppingCartController.addTicketFareToShoppingCart({
      body: getRequestBody(payload),
    });

    return (response.data as ShoppingCartItemResponse).data;
  },

  addCompanyCardTicketFare: async (payload: AddCompanyCardsTicketFareCommand): Promise<void> => {
    await EshopShoppingCartController.addTicketFaresForCompanyCardsToShoppingCart({
      body: getRequestBody(payload),
    });
  },

  addOffense: async (payload: AddOffenseCommand): Promise<ShoppingCartItemVm> => {
    const response = await EshopShoppingCartController.addOffenseToShoppingCart({
      body: getRequestBody(payload),
    });

    return (response.data as ShoppingCartItemResponse).data;
  },

  removeItem: async (id: string): Promise<ApiResponse> => {
    const response = await EshopShoppingCartController.removeItemFromShoppingCart({ path: { id } });
    return response.data as ApiResponse;
  },

  removeAllItems: async (): Promise<ApiResponse> => {
    const response = await EshopShoppingCartController.removeAllItemsFromShoppingCart();
    return response.data as ApiResponse;
  },
};
